/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Accordion } from '../../tool/accordion/accordion';
import { Entity } from './entity';
import { Style } from '../../enum/style.enum';
import { SafeUrl } from '@angular/platform-browser';

/**
 * @deprecated {@see DrivenEntity}
 */
export abstract class VisualEntity extends Entity {
  /**
   * Return the icon of the entity
   */
  public abstract getIcon(): string | SafeUrl;

  /**
   * Return the second label of entity (ex: job, sex, matricule...)
   */
  public abstract getSubLabel(): string;

  /**
   * Return the third label of entity (ex: birthday)
   */
  public abstract getInfo(): string;

  /**
   * return the color of entity
   */
  public abstract getColor(): string;

  /**
   * Get the list of others informations
   * medical, address, activity, scheduler
   */
  public abstract getDetails(): Accordion;

  /**
   * Return if the item is active, clickable, draggable...
   */
  public abstract isActive(): boolean;

  /**
   * Return the font-awesome icon name of status
   */
  public abstract getStatusIcon(): string;

  /**
   * Return the font-awesome icon name of alert
   */
  public abstract getAlertIcon(): { icon: string; style: Style };
}
